import React from "react";
import "../../blocks/Packages/TrainerProfile.css";
import "@fortawesome/fontawesome-free/css/all.css";

import CardModule from "../CardModule";

import image1 from "../../images/trainers/xavi_lift_thecrew.jpg";

function XaviLift() {
  return (
    <>
      {/* ------ BLOCK NEW HEADER -------- */}

      <div className="profile_intro_container">
        <div className="profile_intro_data">
          <div className="profile_intro_card">
            <div className="card_body">
              <div>
                <img
                  className="card_image"
                  src={image1}
                  alt="Juan Carlos González"
                />
              </div>
              <div>
                <h2 className="card_title">Xavi Lift</h2>
                <p className="card_subtitle">Entrenador Personal</p>
                <p className="card_contact">
                  Contacto y reservas: thecrewmallorca@gmail.com
                </p>
                <div className="social_icons">
                  {/* 
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-x-twitter"></i>
                  </a> */}
                  <a
                    href="https://cuerpoenforma.xavilift.es/"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      textDecoration: "none",
                    }}
                  >
                    <p className="card_subtitle" style={{ margin: 0 }}>
                      Web personal de Xavi Lift
                    </p>
                    <i className="fas fa-link"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------ BLOCK OTHER TRAINERS -------- */}
      <div className="package-page__block-other-trainers">
        <CardModule />
      </div>
    </>
  );
}

export default XaviLift;

// <div className="profile_intro_description">
//   <div className="profile_intro_description_text">
//     <p className="profile_intro_description_section">
//       Una Misión Centrada en Ti
//     </p>
//     <p className="profile_intro_description_content">
//       Especialista en recomposición corporal (perdida grasa , aumento
//       fuerza), buscando así una mejora de la condición física y mental,
//       teniendo mejores hábitos con una metodología sostenible y que se
//       adhiera a tus condiciones.
//     </p>
//   </div>
// </div>

//  <div className="profile_intro_services">
//         <div className="profile_intro_services_container">
//           <div class="profile_intro_content">
//             <h2>Bonos de Entrenamiento Personal</h2>
//             <h3 className="profile_intro_services_package">Bono Basic</h3>
//             <ul>
//               <p>
//                 Horas contratadas, valoración y adaptación de entrenos de fuerza
//                 para crear el camino y así conseguir tuS2objetivos. Servicio de
//                 mediciones corporales. Seguimiento alimenticio (control de
//                 macros) y tabla con +de 90 alimentos. Rutina de 4 semanas de
//                 fuerza con pesos y repeticiones apuntados en las tablas.
//                 Seguimiento vía whatsap de la rutina de fuerza. Rutina de
//                 entreno para las semanas contratadas sin material, podrás
//                 realizarlo donde y cuando quieras y con quien quieras
//                 (complemento al entreno de fuerza).
//               </p>
//               <li>1 Entreno 90€ (2 horas)</li>
//               <li>
//                 4 Entrenos 180€ (1 entreno a la semana). Caducidad 4 semanas (2
//                 bonos 330€ caducidad 8 semanas)
//               </li>
//               <li>
//                 8 Entrenos 340€ (2 entrenos a la semana). Caducidad 4 semanas (2
//                 bonos 590€ caducidad 8 semanas)
//               </li>
//               <li>
//                 12 Entrenos 480€ (3 entrenos a la semana). Caducidad 4 semanas
//                 (2 bonos 780€ caducidad 8 semanas)
//               </li>
//               <li>
//                 Entrenos extra después de pagar cualquier tarifa a 50 euros
//               </li>
//             </ul>

//             <h3 className="profile_intro_services_package">Bono Pareja</h3>
//             <ul>
//               {/* <p>
//                ...
//               </p> */}
//               <li>
//                 4 Entrenos 270€ (1 entreno a la semana). Caducidad 4 semanas (2
//                 bonos 480€ caducidad 8 semanas)
//               </li>
//               <li>
//                 8 Entrenos 495€ (2 entrenos a la semana). Caducidad 4 semanas (2
//                 bonos 880€ caducidad 8 semanas)
//               </li>
//               <li>
//                 12 Entrenos 720€ (3 entrenos a la semana). Caducidad 4 semanas
//                 (2 bonos 1.293€ caducidad 8 semanas)
//               </li>
//               <li>
//                 Entrenos extra después de pagar cualquier tarifa a 60 euros
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>
//       <div className="profile_intro_services">
//         <div className="profile_intro_services_container">
//           <h2>Bonos Entrenamiento en Remoto</h2>
//           <ul>
//             <li>
//               1 vídeo llamadas al mes, valoración y adaptación de entrenos de
//               fuerza para crear el camino y así consaguir tuS2objetivos.
//             </li>
//             <li>
//               Rutina de 4 semanas de fuerza con pesos y repeticiones apuntados
//               en las tablas
//             </li>
//             <li>Seguimiento vía whatsap de la rutina de fuerza.</li>
//           </ul>
//           <h3 className="profile_intro_services_package">Tarifa</h3>
//           <ul>
//             <li>
//               <li>3 meses: 255€</li>
//               <li>6 meses: 450€</li>
//               <li>12 meses: 720€</li>
//             </li>
//           </ul>
//         </div>
//       </div>
